import React, { useRef } from "react";
import { StrokeText } from "../components";
import { useOutsideAlerter } from "../hooks";
import { Link, useStaticQuery, graphql } from "gatsby";
import { useMenu } from "../state";

const kebabCase = (string) => {
	return string
		.replace(/\s+/g, "-")
		.toLowerCase()
		.replace(/[^a-zA-Z0-9-_]/g, "");
};

/* Menu
============================================================================= */

const Menu = () => {
	// Config
	const { open, setOpen, setPopupOpen } = useMenu();
	const ref = useRef(null);
	useOutsideAlerter(ref, () => {
		if (open) {
			setOpen(false);
		}
	});
	const data = useStaticQuery(
		graphql`
			query {
				sanityMenu {
					nav_items {
						title
					}
				}
			}
		`
	);

	// Render Menu Items
	const renderMenuItems = () => {
		return data.sanityMenu.nav_items.map((item) => {
			return (
				<MenuLink
					to={`/${kebabCase(item.title)}`}
					label={item.title}
					key={item.title}
				/>
			);
		});
	};

	// Render
	return (
		<nav
			ref={ref}
			className={`fixed z-40 pt-16 px-12 md:-right-4 -right-4 origin-top md:scale-100 scale-[1.06] h-screen md:max-w-lg w-full  bg-gtred transform-gpu ease-out duration-500 transition-transform flex flex-col md:items-end items-center justify-start md:space-y-4 space-y-2 shadow-xl overflow-scroll ${
				open ? "" : "translate-x-full"
			}`}
		>
			<a
				className="cursor-pointer"
				href="https://goodthings2022.cc/gtf_website_menu_gen"
				target="_blank"
				rel="noopener noreferrer"
			>
				<StrokeText
					text="BUY TICKETS"
					size="md:text-3xl text-xl"
					alignment="text-right"
				/>
			</a>
			<MenuLink />
			<MenuLink to="/lineup" label="Lineup" />
			<MenuLink to="/sideshows" label="Sideshows" />
			<MenuLink to="/blog" label="Blog" />
			<MenuLink to="/sponsors" label="Sponsors" />
			{/* <MenuLink to="/essential-workers" label="Essential Workers" /> */}
			{renderMenuItems()}
			<p className="text-md font-light text-white">© 2022 Good Things</p>
		</nav>
	);
};

/* Menu Link
============================================================================= */

const MenuLink = ({ to = "/", label = "Home" }) => {
	// Config
	const { setOpen } = useMenu();

	// Render
	return (
		<Link
			to={to}
			onClick={() => setOpen(false)}
			className="md:text-3xl text-xl font-bold tracking-wide text-right text-white uppercase phosphate"
		>
			{label}
		</Link>
	);
};

/* Export
============================================================================= */

export default Menu;
